import { render, staticRenderFns } from "./BordersEditorComponent.vue?vue&type=template&id=51c63bab&scoped=true"
import script from "./BordersEditorComponent.vue?vue&type=script&lang=js"
export * from "./BordersEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./BordersEditorComponent.vue?vue&type=style&index=0&id=51c63bab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c63bab",
  null
  
)

export default component.exports